import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput";

class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        label: PropTypes.string,
    }

    render() {
        return (
            <ParadigmaModal
                postUrl={api.proyectos.config.presupuesto.tiposdecosto.create}
                onSubmit={(res) => this.props.onSubmit(res)}
                successMessage={"El Tipo de Costo ha sido creado con éxito."}
                title={"Nuevo Tipo de Costo"}
                buttonTitle={"Nuevo Tipo de Costo"}
                buttonIcon={"fa fa-plus fa-lg"}

                buttonLabel={this.props.label}
                saveButton={true}
                closeButton={true}
                className={"ui-modal-dialog"}>
                <div className="ui-form">
                    <section className="ui-section-block">
                        <p className="ui-section-label">Datos del tipo</p>
                        <ParadigmaLabeledInput autoFocus fieldName="nombre" label="Nombre" labelColumns={12} fieldColumns={12} />
                        <ParadigmaLabeledInput fieldName="siglas" label="Siglas" labelColumns={12} fieldColumns={12} />
                    </section>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Create;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_TiposDeCosto/Create.js